export const profileConstants = {
      UPDATE_SELECTED_USER_PROFILE : "UPDATE_SELECTED_USER_PROFILE"
}